package com.partejar.app.core.di

import com.partejar.app.core.preferences.SettingsThemePreferenceRepository
import com.partejar.app.core.preferences.ThemePreferenceRepository
import com.partejar.app.core.session.SessionCoordinator
import com.partejar.app.core.session.SessionIdentityStore
import com.partejar.app.core.session.CurrentWorkspaceRepository
import com.partejar.app.core.session.SettingsCurrentWorkspaceRepository
import com.partejar.app.core.session.SessionLocalStateCleaner
import com.partejar.app.core.session.DefaultSessionLocalStateCleaner
import com.partejar.app.core.security.AppLockCoordinator
import com.partejar.app.feature.auth.data.repository.AuthRepository
import com.partejar.app.feature.account.data.AccountDeletionRepository
import com.partejar.app.feature.home.data.HomeDataSource
import com.partejar.app.feature.home.data.HomeDateTimeProvider
import com.partejar.app.feature.home.data.SystemHomeDateTimeProvider
import com.partejar.app.feature.home.data.remote.HomeRemoteDataSource
import com.partejar.app.feature.home.data.remote.HomeRemoteMapper
import org.koin.dsl.module
import com.partejar.app.feature.workspace.data.RemoteWorkspaceRepository
import com.partejar.app.feature.workspace.data.WorkspaceRepository
import com.partejar.app.feature.gestantes.data.GestantesDataSource
import com.partejar.app.feature.gestantes.data.GestanteClinicalDataSource
import com.partejar.app.feature.gestantes.data.remote.GestantesRemoteDataSource
import com.partejar.app.feature.gestantes.data.remote.GestantesRemoteMapper
import com.partejar.app.feature.equipe.data.EquipeDataSource
import com.partejar.app.feature.equipe.data.remote.EquipeRemoteDataSource
import com.partejar.app.feature.equipe.data.remote.EquipeRemoteMapper
import com.partejar.app.feature.planos.data.PlanosDataSource
import com.partejar.app.feature.planos.data.remote.PlanosRemoteDataSource
import com.partejar.app.feature.planos.data.remote.PlanosRemoteMapper
import com.partejar.app.feature.convite.data.ConviteAceiteDataSource
import com.partejar.app.feature.convite.data.remote.ConviteAceiteRemoteDataSource
import com.partejar.app.feature.profile.data.UserProfileDataSource
import com.partejar.app.feature.profile.data.remote.UserProfileRemoteDataSource
import com.partejar.app.feature.profile.data.remote.UserProfileRemoteMapper
import com.partejar.app.feature.relacionamentos.data.RelacionamentosDataSource
import com.partejar.app.feature.relacionamentos.data.remote.RelacionamentosRemoteDataSource
import com.partejar.app.feature.modeloscontrato.data.ModelosContratoDataSource
import com.partejar.app.feature.modeloscontrato.data.remote.ModelosContratoRemoteDataSource
import com.partejar.app.feature.modeloscontrato.data.remote.ModelosContratoRemoteMapper
import com.partejar.app.feature.contratos.data.ContratosDataSource
import com.partejar.app.feature.contratos.data.remote.ContratosRemoteDataSource
import com.partejar.app.feature.entitlements.data.EntitlementRepository
import com.partejar.app.feature.entitlements.data.remote.EntitlementRemoteDataSource
import com.partejar.app.feature.entitlements.presentation.EntitlementCoordinator
import com.partejar.app.feature.agenda.data.AgendaDataSource
import com.partejar.app.feature.agenda.data.remote.AgendaRemoteDataSource

val repositoryModule = module {
    single<CurrentWorkspaceRepository> {
        SettingsCurrentWorkspaceRepository(settings = get())
    }
    single<SessionLocalStateCleaner> { DefaultSessionLocalStateCleaner(get(), get(), get()) }
    single { AppLockCoordinator(get(), get(), get()) }
    single { AuthRepository(get(), get(), get(), get(), get()) }
    single { AccountDeletionRepository(get(), get()) }
    single<WorkspaceRepository> { RemoteWorkspaceRepository(get(), get()) }
    single<EntitlementRepository> { EntitlementRemoteDataSource(get(), get(), get()) }
    single { EntitlementCoordinator(get()) }
    single { SessionCoordinator(get(), get(), get(), get()) }
    single<SessionIdentityStore> { get<SessionCoordinator>() }
    single<ThemePreferenceRepository> { SettingsThemePreferenceRepository(get()) }
    single<HomeDateTimeProvider> { SystemHomeDateTimeProvider() }
    single { HomeRemoteMapper(get()) }
    single<HomeDataSource> { HomeRemoteDataSource(get(), get(), get(), get()) }
    single { GestantesRemoteMapper() }
    single { GestantesRemoteDataSource(get(), get(), get(), get()) }
    single<GestantesDataSource> { get<GestantesRemoteDataSource>() }
    single<GestanteClinicalDataSource> { get<GestantesRemoteDataSource>() }
    single { EquipeRemoteMapper() }
    single<EquipeDataSource> { EquipeRemoteDataSource(get(), get(), get(), get()) }
    single { PlanosRemoteMapper() }
    single<PlanosDataSource> { PlanosRemoteDataSource(get(), get(), get(), get()) }
    single<ConviteAceiteDataSource> { ConviteAceiteRemoteDataSource(get(), get()) }
    single { UserProfileRemoteMapper() }
    single<UserProfileDataSource> { UserProfileRemoteDataSource(get(), get(), get()) }
    single<RelacionamentosDataSource> { RelacionamentosRemoteDataSource(get(), get(), get()) }
    single { ModelosContratoRemoteMapper() }
    single<ModelosContratoDataSource> { ModelosContratoRemoteDataSource(get(), get(), get(), get()) }
    single<ContratosDataSource> { ContratosRemoteDataSource(get(), get(), get()) }
    single<AgendaDataSource> { AgendaRemoteDataSource(get(), get(), get()) }
}
